import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsPurchaseTermsEnabled } from 'shared/selectors/featureToggle';
import { selectFullPaymentTerm } from 'shared/selectors/purchaseTerms/purchaseTermsV2';

import { PurchaseTermsModalLoadable } from './PurchaseTermsModalLoadable';
import { trackBlockClick, trackBlockShow } from './tracking';
import { PurchaseTerms } from '../../components/PurchaseTerms';
import { selectPurchaseTerms } from '../../selectors/purchaseTerms';

export const PurchaseTermsContainer: React.FC = () => {
  const isPurchaseTermsEnabled = useSelector(selectIsPurchaseTermsEnabled);

  const purchaseTerms = useSelector(selectPurchaseTerms);
  const fullPaymentTerm = useSelector(selectFullPaymentTerm);

  const [isOpen, setIsOpen] = React.useState(false);

  const onClick = React.useCallback(() => {
    trackBlockClick();
    setIsOpen(true);
  }, []);

  if (!isPurchaseTermsEnabled || !purchaseTerms || fullPaymentTerm) {
    return null;
  }

  return (
    <>
      <ActionAfterViewObserver callback={trackBlockShow} triggerOnce>
        <PurchaseTerms onClick={onClick} isModalOpen={isOpen} />
      </ActionAfterViewObserver>
      <PurchaseTermsModalLoadable isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};
